import React from 'react';
import {Switch} from 'react-router-dom';
import {useIntl} from 'react-intl';

import PrivateRoute from '../../components/PrivateRoute';
import withLayout from '../../components/ui/Layout';
import CategoryList from './CategoryList';
import CategoryDetail from './CategoryDetail';
import CreateCategory from './CreateCategory';
import EditCategory from './EditCategory';

function Categories() {
    const intl = useIntl();

    return (
        <Switch data-test='categoriesComponent'>
            <PrivateRoute
                permission='CATEGORIES_INDEX'
                exact
                path='/categories'
                component={withLayout(
                    CategoryList,
                    intl.formatMessage({id: 'ROUTES.CATEGORIES.INDEX'}),
                )}
            />
            <PrivateRoute
                permission='CATEGORIES_CREATE'
                exact
                path='/categories/create'
                component={withLayout(
                    CreateCategory,
                    intl.formatMessage({id: 'ROUTES.CATEGORIES.CREATE'}),
                )}
            />
            <PrivateRoute
                permission='CATEGORIES_EDIT'
                exact
                path='/categories/:id/edit'
                component={withLayout(
                    EditCategory,
                    intl.formatMessage({id: 'ROUTES.CATEGORIES.EDIT'}),
                )}
            />
            <PrivateRoute
                permission='CATEGORIES_SHOW'
                exact
                path='/categories/:id'
                component={withLayout(
                    CategoryDetail,
                    intl.formatMessage({id: 'ROUTES.CATEGORIES.SHOW'}),
                )}
            />
        </Switch>
    );
}

export default Categories;
